import axios, { isAxiosError } from 'axios'

import { notifySessionExpired, SESSION_EXPIRED_HEADER } from './sessionExpiry'
import { TOKEN_REFRESH_HEADER, applyRefreshedToken } from './tokenRefresh'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
})

api.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('authToken')

  // No pisa un Authorization explícito (lo usa UserProfileSelectModal antes de que el
  // token del login llegue a localStorage)
  if (authToken && !config.headers.has('Authorization')) {
    config.headers.set('Authorization', `Bearer ${authToken}`)
  }

  return config
})

// Sólo había interceptor de request: un 401 se propagaba como un error cualquiera y la
// sesión seguía "viva" con un token vencido. Ver sessionExpiry.ts.
api.interceptors.response.use(
  (response) => {
    /*
    Renovacion deslizante: la API devuelve un token nuevo en este header cuando al
    vigente le queda poco. Axios normaliza los nombres a minusculas. Ver tokenRefresh.ts.
    */
    applyRefreshedToken(response.headers?.[TOKEN_REFRESH_HEADER.toLowerCase()] as string | undefined)

    return response
  },
  (error: unknown) => {
    if (isAxiosError(error) && error.response?.status === 401) {
      // No alcanza con el 401: sólo cerramos sesión si la API marcó que el problema
      // es la sesión de Veekls y no un tercero. Ver sessionExpiry.ts.
      const marked = Boolean(error.response.headers?.[SESSION_EXPIRED_HEADER.toLowerCase()])

      notifySessionExpired(error.config?.url ?? '', marked)
    }

    return Promise.reject(error)
  }
)
